import { cleanupTransactionStructuredModelRunner } from '../features/cleanup-transaction';
import { recategorizeStructuredModelRunner } from '../features/recategorize';
import { renamePayeeStructuredModelRunner } from '../features/rename-payee';
import type { TransactionActionCapability } from '../proposalTypes';
import type { TransactionActionRunner, TransactionActionRunnerBuildArgs } from './types';

// One runner instance is registered per TransactionActionRunnerId (see runners/index.ts), so
// a capability-keyed dispatch is needed now that more than one capability uses
// 'structured_model' - each feature still owns its own guarded runner.
const structuredModelRunnersByCapability: Partial<Record<TransactionActionCapability, TransactionActionRunner>> = {
  recategorize: recategorizeStructuredModelRunner,
  rename_payee: renamePayeeStructuredModelRunner,
  cleanup_transaction: cleanupTransactionStructuredModelRunner,
};

export const structuredModelTransactionActionRunner: TransactionActionRunner = {
  id: 'structured_model',
  buildOutput: (buildArgs: TransactionActionRunnerBuildArgs) =>
    structuredModelRunnersByCapability[buildArgs.batch.capability]?.buildOutput(buildArgs) ?? null,
};
